import React from 'react';

function LeaveBehindReplay({ onClick }) {

    return (
        <div onClick={onClick} className="leave-behind-replay">
            <i className="media-icon media-icon--recap"></i>
        </div>
    );

}

export default LeaveBehindReplay;